module.exports = __webpack_public_path__ + "images/logo-alvaro-frischmann.jpg?75bfb37e03c12b250f69d49a5b063068";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/assets/images/fidelidade/logo-alvaro-frischmann.jpg
// module id = 990
// module chunks = 0